import { RouteType } from "types/RouteType";
import { accountingHubRoute } from "@intrasync/accounting";
// The old Premier accounting screens (Dashboard, Purchases, Sales, Payments,
// PO/Invoice conversion, InvoiceDetail) all depend on backend services that
// were dropped when @intrasync/accounting-api took over (invoices, customers,
// vendors, purchase_orders, etc.). They will crash on enter (".find() of
// undefined"), so they're commented out until either rewritten against the
// new accounting module or removed entirely.
// import dashboardRoute from "./Dashboard/AccountingDashboard.Route";
// import purchasesRoute from "./Purchases/Purchases.Route";
// import salesRoute from "./Sales/Sales.Route";
// import paymentsRoute from "./Payments/Payments.Route";
// import costCodeRoute from "./CostCode/costCode.Route";
import holidayScheduleRoute from "./HolidaySchedule/holidaySchedule.Route";
// import poConversionRoute from "./po-conversion/POConversion.Route";
// import invoiceConversionRoute from "./invoice-conversion/InvoiceConversion.Route";
// import invoiceDetailRoute from "./invoice-detail/InvoiceDetail.Route";

const accountingRoutesList: RouteType[] = [
  accountingHubRoute,
  // dashboardRoute,
  // purchasesRoute,
  // salesRoute,
  // paymentsRoute,
  // poConversionRoute,
  // invoiceConversionRoute,
  // invoiceDetailRoute,
  // costCodeRoute,
  ...holidayScheduleRoute,
];

export default accountingRoutesList;
